import { render, staticRenderFns } from "./DesktopButton.vue?vue&type=template&id=1e7c3f5b&scoped=true&"
import script from "./DesktopButton.vue?vue&type=script&lang=js&"
export * from "./DesktopButton.vue?vue&type=script&lang=js&"
import style0 from "./DesktopButton.vue?vue&type=style&index=0&id=1e7c3f5b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e7c3f5b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
